import { useState } from "react";
import { ArrowLeft, BookOpen, Grid3x3 } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { isGuest } from "@/lib/guest";

// Remembered per user (per browser): one choice for regular albums, one for Year Books.
export const useAlbumView = (kind, fallback) => {
  const { user } = useAuth();
  const who = isGuest() ? "guest" : user?.user_id || "public";
  const key = `album-view:${who}:${kind}`;
  const [view, setView] = useState(() => localStorage.getItem(key) || fallback);
  return [view, (v) => { localStorage.setItem(key, v); setView(v); }];
};

export const ViewToggle = ({ value, onChange }) => (
  <div className="view-toggle" role="group" aria-label="Album view" data-testid="album-view-toggle">
    <button className={value === "thumbs" ? "on" : ""} onClick={() => onChange("thumbs")} data-testid="album-view-thumbs"><Grid3x3 size={14} /> <span>Thumbnails</span></button>
    <button className={value === "book" ? "on" : ""} onClick={() => onChange("book")} data-testid="album-view-book"><BookOpen size={14} /> <span>Book</span></button>
  </div>
);

export const albumMeta = (a) => [`${a.item_count} ${a.item_count === 1 ? "photo" : "photos"}`, a.span].filter(Boolean).join(" · ");

// Compact album header: small title, then a thin rule with meta + actions on the same row.
export const AlbumHead = ({ album, onBack, children }) => (
  <header className="album-head" data-testid="album-title">
    {onBack && <button className="album-head-back" onClick={onBack} data-testid="album-back-button"><ArrowLeft size={13} /> Albums</button>}
    <h1 title={album.name} data-testid="album-head-name">{album.name}</h1>
    <div className="album-head-row">
      <span className="album-head-rule" aria-hidden />
      <span className="album-head-meta" data-testid="album-head-meta">{albumMeta(album)}</span>
      <div className="album-head-tools">{children}</div>
    </div>
  </header>
);
